<template>
	<div>
		<v-dialog v-model="dialog_setup_drive" v-if="dialog_setup_drive" persistent no-click-animation transition="slide-y-transition" max-width="320">
	      <v-card>
			<v-card-title class="title noshadow redcolor font18">
				<v-icon class="redcolor mr-3">warning</v-icon>Set Auto Data Backup Now
	      	</v-card-title>

			<!-- <v-divider></v-divider> -->

	      	<!-- <v-card-title full-height class="title noshadow">Setup Drive</v-card-title> -->
	        <v-card-text class="center-align pt-2 font16">
	        	<!-- You need to setup a google drive to keep your data safe &amp; secure. -->
				<p class="mb-1">Why this is Important? <span class="primary-color" @click="fn_watchHelpVideo">Watch video</span></p>
				<p class="mb-1">Keep your Data Safe & Secure</p>				
				<!-- Set up auto data backup now! -->
				<!-- <div redcolor>You might lose your data if not set up.</div> -->

				<!-- <div @click="fn_watchHelpVideo" class="center-align mt-3 pa-2 primary-color video-link-tile" style="border-radius: 5px;"><span>Watch Help Video <v-icon class="font14 ml-1" color="primary" style="border:1px solid; border-radius: 50%;">play_arrow</v-icon></span></div>  -->
	        </v-card-text>
			<v-divider></v-divider>
	        <v-card-actions style="padding:6px 0px;">
	        	<!-- <v-spacer></v-spacer>
      			<v-btn small color="blue darken-1" flat @click="closeDialogWeb">Cancel</v-btn>
	          	<v-btn color="primary" flat outline @click="fn_gotoSetup">Setup Now</v-btn> -->
				  <v-layout row wrap>
	        		<v-flex xs6 sm6 md6 center-align style="border-right:1px #ddd solid">
	        			<v-btn small font-heavy light-opacity-color flat @click="$parent.fn_closeDialog">Later</v-btn>
	        		</v-flex>
	        		<v-flex xs6 sm6 md6 center-align>
	        			<v-btn small font-heavy class="primary-color" flat @click="gotoSetupDrive">Setup Now</v-btn>
	        		</v-flex>
	        	</v-layout>
		    </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>	 	

<script>

export default{
	props:['gotoSetupDrive', 'message'],
	data(){	
		return{
			dialog_setup_drive: false,
		}
	},
	methods: {
		openDialogWeb: function () {	
			this.dialog_setup_drive = true;
		},
		closeDialogWeb: function () {
			this.dialog_setup_drive = false;
		},
		fn_watchHelpVideo: function(){
			this.$root.fn_openExternalUrl('https://www.youtube.com/watch?v=Swi0dXEjHKk&list=PLlyT7aaJmsIsicHYhxa_JWGHA0RK41yuh');
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_drive_alert.vue